import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    type: 'html:attr',
    name: 'widget',
    property: 'data-widget',
    refreshType: 'all',
    targetSelector: '.module',
    default_value: 'carousel',
    options: [
      {
        key: 'carousel',
        value: 'Carousel',
      },
      {
        key: 'verifiedReviewsBadge',
        value: 'Verified Reviews Badge',
      },
      {
        key: 'allReviews',
        value: 'All Reviews',
      },
      {
        key: 'allReviewsText',
        value: 'All Reviews Text',
      },
    ],
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Opinew Reviews Atom Module
 */
export class GpJudgeReviewsCarousel extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Judge Reviews Carousel';
  }

  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'judge-reviews-carousel';
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
